/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UtenteRemoveFilieraPermissionDTO
 */
export interface UtenteRemoveFilieraPermissionDTO {
    /**
     * 
     * @type {number}
     * @memberof UtenteRemoveFilieraPermissionDTO
     */
    idFiliera?: number;
    /**
     * 
     * @type {string}
     * @memberof UtenteRemoveFilieraPermissionDTO
     */
    permissionId?: string | null;
}

/**
 * Check if a given object implements the UtenteRemoveFilieraPermissionDTO interface.
 */
export function instanceOfUtenteRemoveFilieraPermissionDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UtenteRemoveFilieraPermissionDTOFromJSON(json: any): UtenteRemoveFilieraPermissionDTO {
    return UtenteRemoveFilieraPermissionDTOFromJSONTyped(json, false);
}

export function UtenteRemoveFilieraPermissionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UtenteRemoveFilieraPermissionDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idFiliera': !exists(json, 'idFiliera') ? undefined : json['idFiliera'],
        'permissionId': !exists(json, 'permissionId') ? undefined : json['permissionId'],
    };
}

export function UtenteRemoveFilieraPermissionDTOToJSON(value?: UtenteRemoveFilieraPermissionDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idFiliera': value.idFiliera,
        'permissionId': value.permissionId,
    };
}

